import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
    DxTextBoxModule,
    DxFormModule,
    DxValidatorModule,
    DxTextAreaComponent
} from 'devextreme-angular';
import {getSizeQualifier} from 'src/app/services/screen.service';
import {DataSources} from '@services';

@Component({
    selector: 'add-role-form',
    templateUrl: './add-role-form.component.html',
    providers: [DataSources],
    imports: [
        DxTextBoxModule,
        DxFormModule,
        DxValidatorModule,
        CommonModule,
        DxTextAreaComponent,
    ]
})
export class AddRoleFormComponent {
    data: { name?: string; description?: string; } = {};

    getSizeQualifier = getSizeQualifier;

    getData = () => ({...this.data});
}
